import React, {createContext} from "react";

export const LocaleContext = createContext();
